/* mox-draft-state.js – estado global de draft orders (limpio e integrado) */
; (function () {
  // ====== Config/API ======
  const API_BASE = window.MOX_API_BASE;              // defínelo en theme.liquid
  const API_KEY = window.MOX_API_KEY || '';         // opcional

  function headers(extra = {}) {
    return {
      'Content-Type': 'application/json',
      ...(API_KEY ? { 'X-API-Key': API_KEY } : {}),
      ...extra,
    };
  }
  // expone un helper único y consistente
  window.MOX_HEADERS = headers;

  // ====== Utils ======
  async function parseJsonSafe(res) {
    try { return await res.json(); } catch { return null; }
  }

  // Normaliza el objeto draft (devuelve plano)
  function pickDraft(obj) {
    if (!obj) return null;
    if (obj.draft) return obj.draft;
    if (obj.draftOrder) return obj.draftOrder;
    if (obj.data && obj.data.draftOrder) return obj.data.draftOrder;
    return obj;
  }

  function draftHasOnlyDummy(d) {
    const root = d?.draftOrder || d;
    const nodes = root?.lineItems?.nodes || [];
    if (!nodes.length) return false;
    return nodes.every(li => {
      const hasVariant = !!li?.variant?.id || !!li?.variantId;
      const isDummy = !hasVariant && String(li?.title || '').toLowerCase() === 'draft-dummy';
      return isDummy;
    });
  }


  function gidToNum(gid) {
    const m = String(gid || '').match(/(\d+)$/);
    return m ? m[1] : null;
  }

  // Dirección del cliente (inyectada por Liquid en window.BABALU.customer)
  function getCustomerAddress() {
    const a = window.BABALU?.customer?.defaultAddress;
    if (!a) return null;
    return {
      firstName: a.firstName || '',
      lastName: a.lastName || '',
      company: a.company || '',
      address1: a.address1 || '',
      address2: a.address2 || '',
      city: a.city || '',
      province: a.provinceCode || a.province || '',
      country: a.countryCode || a.country || '',
      zip: a.zip || '',
      phone: a.phone || ''
    };
  }

  function hasAddresses(draft) {
    const d = draft?.draftOrder ? draft.draftOrder : draft;
    const shipOk = !!(d?.shippingAddress?.address1);
    const billOk = !!(d?.billingAddress?.address1);
    return shipOk && billOk;
  }

  // Log visual de direcciones (debug amable)
  function logDraftAddresses(draft, label = '[MOX][addr]') {
    const d = draft?.draftOrder ? draft.draftOrder : draft;
    const shipping = d?.shippingAddress || {};
    const billing = d?.billingAddress || {};
    const hasShip = !!shipping.address1;
    const hasBill = !!billing.address1;
    console.groupCollapsed(`${label} shipping=${hasShip} billing=${hasBill}`);
    try { console.table({ shipping, billing }); } finally { console.groupEnd(); }
  }

  // (Opcional) completar direcciones en backend si faltan (requiere endpoint PATCH que hoy no tenemos)
  async function ensureAddressesOnDraft(draft) {
    if (hasAddresses(draft)) return draft;
    // Sin endpoint para actualizar direcciones, devolvemos tal cual.
    return draft;
  }

  // ====== Cálculo de expiración desde config embebida ======
  function readPrereserveConfig() {
    try {
      const node = document.getElementById('mox-prereserva-config');
      return node ? JSON.parse(node.textContent || '{}') : {};
    } catch { return {}; }
  }

  function isWeekendDay(cfg, now = new Date()) {
    const weekendStartsOn = (cfg.weekend_starts_on || 'friday'); // 'friday' | 'saturday'
    const day = now.getDay(); // 0=Dom,1=Lun,...,5=Vie,6=Sáb
    return weekendStartsOn === 'friday'
      ? (day === 5 || day === 6 || day === 0)
      : (day === 6 || day === 0);
  }

  function computeExpirationISO(cfg, nowMs = Date.now()) {
    const H = 3600000;
    const weekend = isWeekendDay(cfg);
    const visibleHours = weekend
      ? Number(cfg.weekend_visible_hours ?? 48)
      : Number(cfg.weekday_visible_hours ?? 24);
    const realHours = weekend
      ? Number(cfg.weekend_real_hours ?? 72)
      : Number(cfg.weekday_real_hours ?? 40);

    return {
      visibleISO: new Date(nowMs + visibleHours * H).toISOString(),
      realISO: new Date(nowMs + realHours * H).toISOString(),
      cfgVersion: String(cfg.version ?? '0'),
    };
  }

  // ====== Estado global MOX_DRAFT ======
  window.MOX_DRAFT = window.MOX_DRAFT || {};
  Object.assign(window.MOX_DRAFT, {
    current: window.MOX_DRAFT.current ?? null,
    refreshing: false,

    // Carga la última draft válida del cliente (ignora expiradas por backend)
    async refreshLatestForCustomer(force = false) {
      const customerId = window.MOX_CUSTOMER_ID;
      if (!customerId) {
        this.current = null;
        window.dispatchEvent(new CustomEvent('mox:draft:none'));
        return null;
      }
      if (this.refreshing && !force) return this.current;
      this.refreshing = true;

      try {
        const res = await fetch(`${API_BASE}/draft-orders/latest-by-customer/${encodeURIComponent(customerId)}?shop=babalu-b2b.myshopify.com`, {
          headers: headers()
        });
        const raw = await parseJsonSafe(res);
        const draft = pickDraft(raw);

        // ignorar drafts que solo tienen el dummy
        if (res.ok && draft?.id && draftHasOnlyDummy(draft)) {
          this.current = null;
          window.dispatchEvent(new CustomEvent('mox:draft:none'));
          return null;
        }

        if (res.ok && draft?.id) {
          const fixed = await ensureAddressesOnDraft(draft);
          logDraftAddresses(fixed, '[MOX][addr] after refreshLatestForCustomer');
          this.current = fixed;
          window.dispatchEvent(new CustomEvent('mox:draft:loaded', { detail: { draft: fixed } }));
          return fixed;
        } else {
          if (this.current?.id) {
            return this.current;
          }
          this.current = null;
          window.dispatchEvent(new CustomEvent('mox:draft:none'));
          return null;
        }
      } catch (e) {
        console.warn('[MOX] No se pudo cargar la draft:', e);
        if (this.current?.id) {
          return this.current;
        }
        this.current = null;
        window.dispatchEvent(new CustomEvent('mox:draft:none'));
        return null;
      } finally {
        this.refreshing = false;
      }
    },

    // Refresca una draft por id numérico (paginado consolidado en backend)
    async refreshById(draftIdNum) {
      if (!draftIdNum) return null;
      if (this.refreshing) return this.current;
      this.refreshing = true;

      try {
        const res = await fetch(`${API_BASE}/draft-orders/${draftIdNum}?shop=babalu-b2b.myshopify.com`, { headers: headers() });
        const raw = await parseJsonSafe(res);
        const draft = pickDraft(raw);

        if (res.ok && draft?.id) {
          const fixed = await ensureAddressesOnDraft(draft);
          logDraftAddresses(fixed, '[MOX][addr] after refreshById');
          this.current = fixed;
          window.dispatchEvent(new CustomEvent('mox:draft:loaded', { detail: { draft: fixed } }));
          return fixed;
        } else {
          if (this.current?.id) {
            return this.current;
          }
          this.current = null;
          window.dispatchEvent(new CustomEvent('mox:draft:none'));
          return null;
        }
      } catch (e) {
        console.warn('[MOX] No se pudo refrescar la draft:', e);
        if (this.current?.id) {
          return this.current;
        }
        return null; // aquí no emites none si ya hay current
      } finally {
        this.refreshing = false;
      }
    },

    async createDraftForCustomer(lineItems) {
      const customerId = window.MOX_CUSTOMER_ID;
      if (!customerId) {
        window.dispatchEvent(new CustomEvent('mox:auth:required'));
        return null;
      }

      try {
        const cfg = readPrereserveConfig();
        const { visible_hours, real_hours, config_version } = pickAdminHours(cfg);

        const addr = getCustomerAddress();
        const payload = {
          customerId,
          lineItems: Array.isArray(lineItems) ? lineItems : [],
          visible_hours,
          real_hours,
          config_version,
        };

        const res = await fetch(`${API_BASE}/draft-orders?shop=babalu-b2b.myshopify.com`, {
          method: 'POST',
          headers: headers(),
          body: JSON.stringify(payload)
        });
        const raw = await parseJsonSafe(res);
        const draft = pickDraft(raw);

        if (res.ok && draft?.id) {
          this.current = draft;
          window.dispatchEvent(new CustomEvent('mox:draft:loaded', { detail: { draft } }));

          setTimeout(() => {
            window.MOX_DRAFT?.refreshLatestForCustomer?.().catch(() => { });
          }, 4000);

          return draft;
        }
        console.warn('[MOX] Error creando draft:', raw);
        return null;
      } catch (e) {
        console.warn('[MOX] Error de red creando draft:', e);
        return null;
      }
    },

    // Agrega ítems (si no hay draft, la crea primero)
    async addItem(input, qty = 1) {
      // normaliza a array de line items { variantId? | title?, quantity }
      const items = (Array.isArray(input) ? input : [{ variantId: input, quantity: qty }])
        .map(x => {
          const li = { quantity: Number(x?.quantity ?? 1) };
          if (x?.variantId) li.variantId = String(x.variantId);
          if (!x?.variantId && x?.title) li.title = String(x.title);
          return li;
        })
        .filter(li => li.quantity > 0 && (li.variantId || li.title));

      if (!items.length) return this.current;

      // si no hay draft → crearla con estos ítems
      if (!this.current?.id) {
        return await this.createDraftForCustomer(items);
      }

      // hay draft → sumar delta
      const gid = this.current.id || this.current.gid;
      const idNum = (String(gid).match(/\d+$/) || [])[0];
      if (!idNum) return this.current;

      try {
        const res = await fetch(`${API_BASE}/draft-orders/${idNum}/items?shop=babalu-b2b.myshopify.com`, {
          method: 'POST',
          headers: headers(),
          body: JSON.stringify({ lineItems: items })
        });
        const raw = await parseJsonSafe(res);

        // expirada (backend devuelve 409) → reset y crear nueva con los items
        if (res.status === 409 && raw?.error === 'draft_expired') {
          this.current = null;
          window.dispatchEvent(new CustomEvent('mox:draft:none'));
          return await this.createDraftForCustomer(items);
        }

        if (res.status === 409 && raw?.error === 'insufficient_inventory') {
          this.current = null;
          window.dispatchEvent(new CustomEvent('mox:draft:none'));
          alert("La cantidad solicitada supera el stock disponible");
        }

        const draft = pickDraft(raw);
        if (res.ok && draft?.id) {
          this.current = draft;
          window.dispatchEvent(new CustomEvent('mox:draft:loaded', { detail: { draft } }));
          return draft;
        }

        console.warn('[MOX] addItem falló:', raw);
        return this.current;
      } catch (e) {
        console.warn('[MOX] Error de red en addItem:', e);
        return this.current;
      }
    },

    // Agrega ítems usando variantId NUMÉRICO (no GID)
    // Agrega ítems usando variantId NUMÉRICO (con logs y defensas)
    // Agrega ítems usando variantId NUMÉRICO (robusto con objetos/primitivos)
    async addItemInput(input, qty = 1) {
      const dbg = (...a) => console.log('[MOX:addItemInput]', ...a);

      // ✅ Normaliza correctamente:
      // - Array -> tal cual
      // - Objeto -> [objeto]
      // - Primitivo (num/string) -> [{ variantId: input, quantity: qty }]
      const arr = Array.isArray(input)
        ? input
        : (typeof input === 'object' && input !== null)
          ? [input]
          : [{ variantId: input, quantity: qty }];

      dbg('raw input=', JSON.parse(JSON.stringify(arr)));

      const itemsPre = arr.map((x) => {
        const li = { quantity: Number(x?.quantity ?? 1) };

        // Sanea variantId a NÚMERO
        let v = x?.variantId;
        if (v && typeof v === 'object') {
          const m = String(v).match(/\d+/);
          v = m ? Number(m[0]) : NaN;
        } else if (typeof v === 'string') {
          const m = v.match(/\d+/);
          v = m ? Number(m[0]) : NaN;
        } else if (typeof v !== 'number') {
          v = NaN;
        }
        if (Number.isFinite(v)) li.variantId = v;

        if (!Number.isFinite(v) && x?.title) li.title = String(x.title);
        return li;
      });

      dbg('itemsPre=', itemsPre);

      // const items = itemsPre.filter(li =>
      //   Number.isFinite(li.quantity) && li.quantity > 0 && (typeof li.variantId === 'number' || li.title)
      // );

      const items = itemsPre.filter(li =>
        Number.isFinite(li.quantity) && li.quantity !== 0 && (typeof li.variantId === 'number' || li.title)
      );


      dbg('items=', items);
      if (!items.length) {
        dbg('early-return: items vacío');
        return this.current;
      }

      // ===== igual a tu lógica actual desde aquí =====
      if (!this.current?.id) {
        dbg('no current draft → createDraftForCustomer(items)');
        const created = await this.createDraftForCustomer(items);
        dbg('createDraftForCustomer →', created?.id || created);
        return created || this.current;
      }

      const gidLike = this.current?.id || this.current?.gid || this.current?.draftOrder?.id || this.current?.draftOrder?.gid || '';
      const idNumStr = String(gidLike).match(/\d+$/)?.[0] || '';
      const idNum = Number(idNumStr) || 0;
      dbg('current idNum=', idNum, 'from=', gidLike);

      if (!idNum) {
        dbg('idNum inválido → crear nueva draft');
        const created = await this.createDraftForCustomer(items);
        dbg('fallback createDraftForCustomer →', created?.id || created);
        return created || this.current;
      }

      if (!API_BASE) {
        console.warn('[MOX:addItemInput] API_BASE no definido');
        return this.current;
      }

      const url = `${API_BASE}/draft-orders/${idNum}/items?shop=babalu-b2b.myshopify.com`;
      dbg('POST →', url, { lineItems: items });

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: headers(),
          body: JSON.stringify({ lineItems: items })
        });
        const raw = await parseJsonSafe(res);
        dbg('status=', res.status, 'response=', raw);

        if (res.status === 409 && raw?.error === 'draft_expired') {
          dbg('draft_expired → recreando');
          this.current = null;
          window.dispatchEvent(new CustomEvent('mox:draft:none'));
          const recreated = await this.createDraftForCustomer(items);
          dbg('recreated →', recreated?.id || recreated);
          return recreated || this.current;
        }

        const draft = pickDraft(raw);
        if (res.ok && draft?.id) {
          this.current = draft;
          //window.dispatchEvent(new CustomEvent('mox:draft:loaded', { detail: { draft } }));
          // 👇 forza la apertura del drawer (igual que tu flujo anterior)
          window.dispatchEvent(new CustomEvent('mox:shadow:open'));
          return draft;
        }


        console.warn('[MOX:addItemInput] respuesta no OK', res.status, raw);
        return this.current;
      } catch (e) {
        console.warn('[MOX:addItemInput] Error de red:', e);
        return this.current;
      }
    },

  });

  // ====== Boot seguro al cargar ======
  // ====== Boot seguro al cargar ======
  window.bootDraftRefresh = function bootDraftRefresh(force = false) {
    if (window.MOX_CUSTOMER_ID) {
      window.MOX_DRAFT.refreshLatestForCustomer(force);
    } else {
      window.MOX_DRAFT.current = null;
      window.dispatchEvent(new CustomEvent('mox:draft:none'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDraftRefresh, { once: true });
  } else {
    bootDraftRefresh();
  }

  // ====== DEBUG helper ======
  window.moxDebugDraft = function () {
    if (!window.MOX_DRAFT?.current) {
      console.warn('[MOX][addr] No hay draft cargada.');
      return;
    }
    const d = window.MOX_DRAFT.current?.draftOrder || window.MOX_DRAFT.current;
    console.groupCollapsed('[MOX][addr] estado actual');
    console.table({
      shipping: d?.shippingAddress || {},
      billing: d?.billingAddress || {},
    });
    console.groupEnd();
  };
})();

function pickAdminHours(cfg) {
  const weekendStartsOn = cfg.weekend_starts_on || 'friday';
  const day = new Date().getDay(); // 0=Dom,1=Lun,...,6=Sáb
  const isWeekend = weekendStartsOn === 'friday'
    ? (day === 5 || day === 6 || day === 0)
    : (day === 6 || day === 0);

  return {
    visible_hours: Number(isWeekend ? cfg.weekend_visible_hours : cfg.weekday_visible_hours),
    real_hours: Number(isWeekend ? cfg.weekend_real_hours : cfg.weekday_real_hours),
    config_version: String(cfg.version ?? '0'),
  };
}